import { render, staticRenderFns } from "./related-product-detail.vue?vue&type=template&id=61522968&scoped=true&"
import script from "./related-product-detail.vue?vue&type=script&lang=js&"
export * from "./related-product-detail.vue?vue&type=script&lang=js&"
import style0 from "./related-product-detail.vue?vue&type=style&index=0&id=61522968&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61522968",
  null
  
)

export default component.exports